import { Component } from '@angular/core';

@Component({
  selector: 'app-chat-center',
  imports: [],
  templateUrl: './chat-center.html',
  styleUrl: './chat-center.scss',
})
export class ChatCenter {
  isLoading: boolean = true;
}
